import { Card, Row, Col, Statistic } from "antd";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import classes from "./operational.module.scss";
import { Typography } from "antd";
const { Title, Text } = Typography;

const Operational = () => {
  // Dummy KPIs
const operationalKpis = [
  { title: "Delivery Velocity", value: "92%", suffix: "" },
  { title: "Vendor SLA Compliance", value: "96%", suffix: "" },
  { title: "Production Efficiency", value: "89%", suffix: "" },
  { title: "Incident Rate", value: "3.5%", suffix: "" },
];

// Dummy Operations Trend Chart
const operationsTrendChart = {
  chart: { type: "line" },
  title: { text: "Operations Trend Over Time" },
  xAxis: { categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"] },
  yAxis: { title: { text: "Operational Score (%)" } },
  series: [
    {
      name: "Efficiency Score",
      data: [70, 75, 80, 85, 88, 89],
    }
  ]
};

  return (
    <>
      {" "}
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0 }}>
          Operational System
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Show operations status, vendor performance, delivery speed
        </Text>
      </div>
      <div style={{ padding: "20px" }}>
      {/* KPI Cards */}
      <Row gutter={[16, 16]}>
        {operationalKpis.map((kpi, index) => (
          <Col span={6} key={index}>
            <Card>
              <Statistic title={kpi.title} value={kpi.value} suffix={kpi.suffix} />
            </Card>
          </Col>
        ))}
      </Row>

      {/* Operations Trend Chart */}
      <Row style={{ marginTop: 30 }}>
        <Col span={24}>
          <Card title="Operations Trend">
            <HighchartsReact highcharts={Highcharts} options={operationsTrendChart} />
          </Card>
        </Col>
      </Row>
    </div>
    </>
  );
};
export default Operational;
